export default "__VITE_ASSET__B3cIMG8P__"